import type { MouseEvent } from "react";

export default function preventNavigation(evt: MouseEvent<HTMLAnchorElement>) {
  evt.preventDefault();
  evt.stopPropagation();
  evt.nativeEvent.stopImmediatePropagation();
}
